import { Component, inject } from '@angular/core';
import {VwuiModalConfig, VwuiModalRef} from '@recognizebv/vwui-angular';
import {CompanyType} from '../../models/user/user';

@Component({
    standalone: false,
    selector: 'app-publish-tis-version-modal',
    templateUrl: './publish-tis-version-modal.component.html'
})
export class PublishTisModalComponent {
    modalConfig = inject<VwuiModalConfig<{
    companyType: CompanyType;
}>>(VwuiModalConfig);
    modalRef = inject(VwuiModalRef);


    public loading = false;
    public companyType: CompanyType;

    constructor() {
        const modalConfig = this.modalConfig;

        this.companyType = modalConfig.data.companyType;
    }

    async submit() {
        this.modalRef.close(true);
    }

}
